import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getLastRazorpayOrderId } from '../utils/lastOrder';

const OrderSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { outletId: outletIdFromPath } = useParams();
    const outletId =
        outletIdFromPath ||
        localStorage.getItem('outletId');
    const razorpayOrderId =
        location.state?.razorpayOrderId ||
        getLastRazorpayOrderId(outletId);

    return (
        <Box
            sx={{
                minHeight: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                px: 3,
                background:
                    'linear-gradient(160deg, #e8f7ef 0%, #f5fbf8 40%, #ffffff 100%)',
            }}
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                style={{
                    width: '100%',
                    maxWidth: 380,
                    textAlign: 'center',
                }}
            >
                <Box
                    sx={{
                        width: 88,
                        height: 88,
                        mx: 'auto',
                        mb: 2.5,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background:
                            'linear-gradient(145deg, #25ba6c, #1d9e59)',
                        boxShadow:
                            '0 16px 36px rgba(37, 186, 108, 0.28)',
                    }}
                >
                    <CheckCircleRoundedIcon
                        sx={{ fontSize: 52, color: '#fff' }}
                    />
                </Box>

                <Typography
                    sx={{
                        fontSize: 26,
                        fontWeight: 800,
                        color: '#17364a',
                        mb: 1,
                    }}
                >
                    Order placed!
                </Typography>

                <Typography
                    sx={{
                        fontSize: 15,
                        color: '#577383',
                        lineHeight: 1.6,
                        mb: 1,
                    }}
                >
                    Your order has been sent to the cafe.
                    We&apos;ll start preparing it shortly.
                </Typography>

                <Button
                    fullWidth
                    variant="contained"
                    onClick={() =>
                        navigate(
                            outletId ? `/${outletId}/order-status` : '/',
                            {
                                replace: true,
                                state: { razorpayOrderId },
                            }
                        )
                    }
                    sx={{
                        mt: 4,
                        minHeight: 52,
                        borderRadius: '14px',
                        textTransform: 'none',
                        fontWeight: 800,
                        fontSize: 16,
                        backgroundColor: '#003049',
                        '&:hover': {
                            backgroundColor: '#00263a',
                        },
                    }}
                >
                    View order status
                </Button>

                <Button
                    fullWidth
                    variant="text"
                    onClick={() =>
                        navigate(
                            outletId ? `/${outletId}` : '/',
                            { replace: true }
                        )
                    }
                    sx={{
                        mt: 1,
                        minHeight: 44,
                        borderRadius: '14px',
                        textTransform: 'none',
                        fontWeight: 800,
                        fontSize: 15,
                        color: '#306781',
                    }}
                >
                    Order more
                </Button>
            </motion.div>
        </Box>
    );
};

export default OrderSuccess;
